import { createContext, useContext } from 'react';

const ValidRoutePathsContext = createContext<string[]>([]);

export const ValidRoutePathsProvider = ValidRoutePathsContext.Provider;
export const useValidRoutePaths = () => useContext(ValidRoutePathsContext);
